export const snapshotQueryKeyMap = {
  snapshots: (params?: object) => ['snapshots', params],
  snapshot: (id?: string | null) => ['snapshot', id],
};

export const snapshotInvalidateListMap = {
  updateList: () => [
    snapshotQueryKeyMap.snapshots(),
    snapshotQueryKeyMap.snapshot(),
  ],
};
